export function initPortfolioSlider() {
  const section = document.querySelector('[data-portfolio-section]');
  if (!section) return;

  const scroller = section.querySelector('[data-portfolio-scroll]');
  const prevButton = section.querySelector('[data-portfolio-prev]');
  const nextButton = section.querySelector('[data-portfolio-next]');

  if (!scroller || !prevButton || !nextButton) return;

  const scrollByAmount = (direction) => {
    const amount = scroller.offsetWidth * 0.7;
    scroller.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  };

  prevButton.addEventListener('click', () => scrollByAmount('left'));
  nextButton.addEventListener('click', () => scrollByAmount('right'));
}
